<template>
  <div>
    <div v-if="isWidgetOpen" class="widget__container">
      <div class="widget__header">
        <div class="headers">
          <div class="widget__title">{{ $tc("course.question", 2) }}</div>
          <BaseSelect
            v-model="questionTypes"
            solo
            outlined
            :items="[
              { id: 1, name: $t('course.myQuestion') },
              { id: 2, name: $t('course.forms.question.datatype.label') },
              { id: 3, name: $tc('course.customQuestion') },
            ]"
            :placeholder="
              $t('workflow.targetStatus.createAndEditForm.targetStatus') + ' *'
            "
            item-text="name"
            item-value="id"
            class="widget__select"
          />
        </div>

        <BaseIcon
          icon="$mdiClose"
          color="#CFCFDC"
          class="icon-modal"
          @click.prevent="closeWidget"
        />
      </div>
      <div class="widget__content">
        <template v-if="questionTypes === 1">
          <questions-template-widget />
        </template>
        <template v-else-if="questionTypes === 2">
          <data-type-question-widget />
        </template>

        <template v-else>
          <custom-question-widget />
        </template>
      </div>
    </div>
    <div v-else class="widget_closed">
      <BaseButton class="btn__actions" @click="isWidgetOpen = !isWidgetOpen">
        <span class="q-lable"> {{ $t("course.insertQuestion") }}</span>
        <BaseIcon icon="$mdiPlus" small color="white" />
      </BaseButton>
    </div>
  </div>
</template>

<script>
import CustomQuestionWidget from "./CustomQuestionWidget.vue";
import DataTypeQuestionWidget from "./DataTypeQuestionWidget.vue";
import QuestionsTemplateWidget from "./QuestionsTemplateWidget.vue";

export default {
  name: "QuestionsCreate",
  components: {
    DataTypeQuestionWidget,
    QuestionsTemplateWidget,
    CustomQuestionWidget,
  },
  data() {
    return {
      questionTypes: 1,
      isWidgetOpen: false,
    };
  },
  methods: {
    closeWidget() {
      this.isWidgetOpen = false;
      this.questionTypes = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.widget_closed {
  position: fixed;
  bottom: 90px;
  right: 60px;
  z-index: 1;
  .btn__actions {
    background: #2536cc !important;
  }
  .q-lable {
    color: white;
  }
}
.widget__container {
  z-index: 1;
  position: fixed;
  bottom: 30px;
  right: 45px;
  width: 550px;
  min-height: 500px;
  background: white;
  border: 2px solid #2536cc;
  border-radius: 6px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  .widget__header {
    display: flex;
    align-items: center;
    .headers {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: calc(100% - 35px);
      .widget__title {
        font-size: 24px;
        color: #2536cc;
        text-decoration: underline;
      }
      .widget__select {
        margin: auto;
        max-width: 260px;
      }
    }
    .icon-modal {
      margin-left: auto;
      transform: translateY(-15px);
    }
  }
  .widget__content {
    width: 100%;
    margin-top: 16px;
  }
}
.widget__select {
  ::v-deep .v-text-field__details {
    display: none;
  }
}
</style>
